import {
  IApplyOptionsCommonSearchParam,
  IApplyPlanTableReport,
} from "src/Interfaces/applyOption";
import TableTemplate from "../../TableTemplate/tableTemplate";
import { CommonTableUI } from "../../TableTemplate/common";
import { getApplyPlanTable } from "src/Requests/applyOption";
import { Additional } from "./Additional";
import { getKeyValueJSX } from "src/Utils/commonJSX";
import { addSeperatorToInput } from "src/helper";

interface IProps {
  searchParams: IApplyOptionsCommonSearchParam;
  refreshFlag: boolean;
}

const ApplyPlanTable = ({ searchParams, refreshFlag }: IProps) => {
  return (
    <TableTemplate<IApplyOptionsCommonSearchParam, IApplyPlanTableReport>
      TableUI={({ reports, onAction, setSortingType, sortingType }: any) => (
        <div className="w-full flex flex-col justify-start items-start gap-2">
          <div className="grid grid-cols-7 w-full">
            {getKeyValueJSX(
              "تعداد بدون پورتفو",
              addSeperatorToInput(
                reports.totalNoPortfo || "-",
                "negativeDecimalNumbers",
              ),
            )}
            {getKeyValueJSX(
              "نیاز به مازاد",
              addSeperatorToInput(
                reports.totalUsersWithAdditionalPower || "-",
                "negativeDecimalNumbers",
              ),
            )}
            {getKeyValueJSX(
              "تعداد غیر فعال",
              addSeperatorToInput(
                reports.totalInactive || "-",
                "negativeDecimalNumbers",
              ),
            )}
            {getKeyValueJSX(
              "تعداد آماده ارسال",
              addSeperatorToInput(
                reports.totalReadyToSend || "-",
                "negativeDecimalNumbers",
              ),
            )}
            {getKeyValueJSX(
              "تعداد انجام شده",
              addSeperatorToInput(
                reports.totalSuccess || "-",
                "negativeDecimalNumbers",
              ),
            )}
            {getKeyValueJSX(
              "تعداد در انتظار پاسخ",
              addSeperatorToInput(
                reports.totalPending || "-",
                "negativeDecimalNumbers",
              ),
            )}
            {getKeyValueJSX(
              "تعداد دارای خطا",
              addSeperatorToInput(
                reports.totalFail || "-",
                "negativeDecimalNumbers",
              ),
            )}
          </div>
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            setSortingType={setSortingType}
            sortingType={sortingType}
            tableBoxClassName="max-h-[500px] overflow-auto"
            AdditionalBody={Additional}
            refreshFlag={refreshFlag}
            withSelect
          />
        </div>
      )}
      getDataTable={getApplyPlanTable}
      searchParameters={searchParams}
      pagesize={200}
      withSort
    />
  );
};

export default ApplyPlanTable;
